/* eslint-disable no-magic-numbers */
const BREAKPOINTS = {
  DESKTOP: 1024
};

const SETTINGS = {
  THROTTLE_DELAY_SMALL: 50,
  THROTTLE_DELAY: 500,
  SEARCH_DEBOUNCE_DELAY: 300,
  MINICART_DEBOUNCE_DELAY: 300,
  FILTER_UPDATE_DELAY: 250,
  FILTER_DRAW_ANIMATION_TIME: 300,
  POPUP_ANIMATION_TIME: 500,
  MOBILE_HEADER_STICKY_SCROLL_THRESHOLD: 100,
  MEGAMENU_THRESHOLD: 50
};

const CART = {
  FORM_SUBMIT_TIMEOUT: 2000
};

const PRODUCT_RECENTLY_VIEWED = {
  MINIMUM_PRODUCTS_TO_SHOW: 3,
  MAX_CONTENT_CHARS_AMOUNT: 26
};

const CLASSES = {
  TRANSLATE_X_0: 'translate-x-0',
  TRANSLATE_Y_0: 'translate-y-0!',
  TRANSLATE_X_100: 'translate-x-full',
  TRANSLATE_Y_100: 'translate-y-full',
  OVERFLOW_HIDDEN: 'overflow-hidden',
  OVERFLOW_VISIBLE: 'overflow-visible',
  SCROLLABLE: 'overflow-y-auto',
  HIDDEN: 'hidden',
  FLEX: 'flex',
  BG_WHITE: 'bg-white',
  BG_LIGHT_GREY: 'bg-light-grey',
  BG_UPSELL_ACTIVE: 'bg-[#C7CEE0]',
  BG_GHOST: 'bg-ghost',
  BORDER_GHOST: 'border-ghost',
  LINE_CLAMP_NONE: 'line-clamp-none',
  POINTER_EVENTS_NONE: 'pointer-events-none',
  OPACITY_0: 'opacity-0',
  OPACITY_50: 'opacity-50',
  OPACITY_100: 'opacity-100'
};

const ARIAS = {
  EXPANDED: 'aria-expanded',
  SELECTED: 'aria-selected',
  PRESSED: 'aria-pressed',
  ACTIVE_DESCENDANT: 'aria-activedescendant',
  LABEL: 'aria-label'
};

const SWIPER = {
  SLIDE_CLASS: '.swiper-slide'
};

const MINICART = {
  RELATED_SECTION_ID: 'minicart-related-products',
  RELATED_PRODUCTS_LIMIT: 4,
  SCROLL_LOCK_TOKEN: 'minicart'
};

const CART_TOAST = {
  AUTO_HIDE_MS: 5000
};

const MOBILE_VARIANT_PICKER = {
  SCROLL_LOCK_TOKEN: 'mobile-variant-picker',
  SWATCH_ACTIVE_CLASSES: 'border-2 border-dark-charcoal',
  SWATCH_INACTIVE_CLASSES: 'border border-geyser',
  SWATCH_UNAVAILABLE_CLASSES: 'relative overflow-hidden opacity-50 cursor-not-allowed after:content-[\'\'] after:absolute after:left-[-10%] after:top-1/2 after:w-[120%] after:h-px after:-translate-y-1/2 after:rotate-[-14deg] after:bg-dark-charcoal/70'
};

const SEARCH = {
  SCROLL_LOCK_TOKEN: 'predictive-search'
};

const IMAGES = {
  SIZES: '(max-width: 1023px) 83vw',
  WIDTHS: [360, 540, 720],
  DEFAULT_WIDTH: 720,
  SHOPIFY_CDN_HOST: 'cdn.shopify.com'
};

const FBT = {
  PRODUCT_COUNT: 2,
  CENTS_DIVISOR: 100,
  DECIMAL_PLACES: 2
};

const UPSELL_TABS = {
  MINIMUM_TABS: 2
};

const OKENDO = {
  API_BASE: 'https://api.okendo.io/v1',
  MAX_RATING: 5,
  DEFAULT_LIMIT: 10
};

const SELECTORS = {
  LOADING_SPINNER: '[data-loading-spinner]'
};

const PREDICTIVE_SEARCH = {
  // Shopify caps predictive search at 10 results per resource type per request
  MAX_RESULTS_PER_TYPE: 10
};

const ARTICLE_SEARCH_GRID = {
  // Minimum characters before a search query triggers a fetch — avoids
  // firing noisy requests on every single keystroke
  MIN_SEARCH_LENGTH: 2,
  // Placeholder token substituted with the actual count in the status
  // template string. Must match the sentinel passed from the Liquid side
  // (see `data-status-results-template` on the section root).
  STATUS_COUNT_PLACEHOLDER: '__COUNT__',
  // Classes applied to the load-more button while a fetch is in flight
  LOADING_CLASSES: [CLASSES.OPACITY_50, CLASSES.POINTER_EVENTS_NONE],
  // Selectors used in multiple places throughout the module — single-use
  // selectors are inlined at their call site
  SELECTORS: {
    FILTER_TAG: '[data-filter-tag]',
    GRID_CONTAINER: '[data-article-grid-container]',
    LOAD_MORE: '[data-load-more]',
    LOAD_MORE_BTN: '[data-load-more-button]',
    ARTICLE_CARD: '[data-article-card]'
  }
};

export {
  BREAKPOINTS,
  SETTINGS,
  CART,
  PRODUCT_RECENTLY_VIEWED,
  CLASSES,
  ARIAS,
  SWIPER,
  MINICART,
  CART_TOAST,
  MOBILE_VARIANT_PICKER,
  SEARCH,
  IMAGES,
  FBT,
  UPSELL_TABS,
  OKENDO,
  SELECTORS,
  ARTICLE_SEARCH_GRID,
  PREDICTIVE_SEARCH
};
